import BestBuy from "../src/components/BestBuy";
export default BestBuy;